import { JobService } from 'src/app/core/services/job.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';

export class JobBoardsSearchHistoryInfiniteScrollContainer {
  searchHistory: any[] = [];
  busy = false;
  searchHistoryExistFlag = true;
  currentPromise: any = null;
  disableInfiniteScroll = false;
  searchHistoryQueryFilter = {
    pageNum: 1,
    size: 5
  };

  constructor(
    private jobId: any,
    private jobBoards: any[],
    private jobService: JobService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) {}

  getNext() {
    if (this.busy) { return; }
    this.busy = true;

    this.currentPromise = this.jobService.getJobBoardsSearchHistory(
      this.jobId,
      this.searchHistoryQueryFilter.pageNum,
      this.searchHistoryQueryFilter.size,
      (data: any) => {
        if (data !== undefined && data !== 'user cancellation') {
          if (data.length > 0) {
            data.forEach((search: any) => {
              search.jobBoards = angular.copy(this._addJobBoardDetails(search.jobBoardId));
              delete search.jobBoardId;
              this.searchHistory.push(search);
            });
            if (data.length < this.searchHistoryQueryFilter.size) {
              this.disableInfiniteScroll = true;
            } else {
              this.searchHistoryQueryFilter.pageNum++;
            }
          } else {
            this.disableInfiniteScroll = true;
          }
          this.searchHistoryExistFlag = this.searchHistory.length > 0;
        }
        this.busy = false;
      },
      (error: any) => {
        this.busy = false;
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    );
  }

  private _addJobBoardDetails(jobBoardIds: any[]) {
    const jobBoards: any[] = [];
    (jobBoardIds || []).forEach((jobBoardId: any) => {
      const jobBoard = this.jobBoards.find((board) => board.id === jobBoardId);
      jobBoards.push(jobBoard);
    });
    return jobBoards;
  }
}

declare var angular: any;
